import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './completeProfile.module.scss';
import t6 from '../../../Assets/images/image 26.png';
import t5 from '../../../Assets/images/image 25.png';
import t3 from '../../../Assets/images/image 23.png';

export default function CompleteProfile(props) {
  const { columnSize = 8, contentOffset = 2 } = props;
  const [t] = useTranslation();

  return (
    <>
      <div className="row py-4">
        <div className={`col-${columnSize} offset-${contentOffset} text-center`}>
          <div className={`${styles['benefits-block']} d-block p-3 px-4`}>
            <h5 className="text-center">
              {t('profile.builder.benefits')}
              <br />
              {t('profile.builder.icontractoffer')}
            </h5>
            <div className="d-flex flex-row flex-wrap py-4 justify-content-around gap-4">
              <div className={styles.pbSevenCard}>
                <img src={t6} alt="t6" className="pb-3" height="80px" />
                <h6 className="text-center">{t('profile.builder.aijob')}</h6>
              </div>
              <div className={styles.pbSevenCard}>
                <img src={t5} alt="t5" className="pb-3" height="80px" />
                <h6 className="text-center">{t('profile.builder.automatedalert')}</h6>
              </div>
              <div className={styles.pbSevenCard}>
                <img src={t3} alt="t3" className="pb-3" height="80px" />
                <h6 className="text-center">{t('profile.builder.oneclick')}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row pt-5">
        <div className="col-12 text-center">
          <Link to="/dashboard" className="button p-3 px-5 mt-4" title="" data-bs-toggle="tooltip">
            <span className="d-inline">{t('profile.builder.continuedashboard')}</span>
          </Link>
        </div>
        <div className="col-12 text-center mt-3">
          <Link to="/dashboard/jobs" className={`${styles.pSeven_link} mt-4 text-decoration-none`}>
            <span>{t('profile.builder.returnjob')}</span>
          </Link>
        </div>
      </div>
    </>
  );
}
